import React,{useEffect, useState, useRef} from 'react';
import './credits.css';

function Credits({goMenu}) {
    const wrap = useRef(null);

  useEffect(() => {
    async function start(){
    await changeSetting(wrap,"current.style.opacity", 0, "", 0.02);
    await changeSetting(wrap,"current.style.zIndex", 0, "", 10);
  }
  start();
},[]);

  async function goToMenu(){
    await changeSetting(wrap,"current.style.zIndex", 10, "", 10);
    await changeSetting(wrap,"current.style.opacity", 1, "", 0.02);
    goMenu();
  }

  function changeSetting(obj, setting, changeTo, um, speed, char){
    return new Promise((resolve, reject) => {
      const props = setting
          .split(/[./[\]]/g)
          .filter(p => p);
      const prop = props.pop();
      const parent = props.reduce((result, key) => result[key], obj);
      //
      var i;
      if(setting == "current.style.transform" || setting == "style.transform"){
        i = Math.round(parseFloat(parent[prop].split("(")[1].split(")")[0]));
      }else{
        i = Math.round(parseFloat(parent[prop]));
      }
      let slowDownTrigger = 0;
    //  if(char){//delete
    //slowDownTrigger = Math.round(parseFloat(Math.abs((char.initialPointX[0]-char.destinationPointX)/char.speed)*0.8));//moment of slower of char
    //}
    //  let slowDownCounter=0;
      let slower = 8;
      change();
    function change(){
      //slowDownCounter++;
    //  if(slowDownCounter > slowDownTrigger && char != undefined){ //delete
    //    slower+=3; //slower of char
    //  }
    //  console.log(slower);
      if(i>changeTo){
        i-=speed;
        if(i<changeTo){
          i = changeTo;
          if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
            parent[prop] = "scale("+i+")";
          }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
            parent[prop] = "rotateY("+i+"deg)";
          }else{
            parent[prop] = i+um;
          }
          resolve();
          return;
        }
    }else if(i<changeTo){
      i+=speed;
      if(i>changeTo){
        i = changeTo;
        if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
          parent[prop] = "scale("+i+")";
        }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
          parent[prop] = "rotateY("+i+"deg)";
        }else{
          parent[prop] = i+um;
        }
        resolve();
        return;
      }
    }else{
      if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
        parent[prop] = "scale("+i+")";
      }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
        parent[prop] = "rotateY("+i+"deg)";
      }else{
        parent[prop] = i+um;
      }
      resolve();
      return;
    }
    if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
      parent[prop] = "scale("+i+")";
    }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
      parent[prop] = "rotateY("+i+"deg)";
    }else{
      parent[prop] = i+um;
    }
  setTimeout(change, slower);
  return;
  }
  });
  }

return(
<div className='menu'>
<div className='clickWrap' id='wrap' ref={wrap} style={{opacity:1,zIndex:10}}></div>
<div className="blurtop"></div>
<div className="creditTop">
<div className="arrowBack2" onClick={goToMenu}>
    <div></div>
</div>
<h2>Credits</h2>
</div>
<div className="credits">
<h3>Story, art, animations, code and design by <a href="https://almondraf.newgrounds.com/" target="_blank"><span>AlmondRaf</span></a></h3>
<h3>Translation and editing by <a href="https://giantapple.newgrounds.com/" target="_blank"><span>GiantApple</span></a></h3>
<h3>Great thanks to my supporters:</h3>
<ul>
  <li>CuteKitten16</li>
  <li>No State</li>
  <li>Biglo</li>
  <li>Mald</li>
  <li>Chingiz</li>
</ul>
</div>
<div className="blurbottom"></div>
</div>
);

}

export default Credits;
